<template>
  <div
    :class="bem()"
  >
    <div :class="bem('titles-container')">
      <div :class="bem('titles')">
        <VisionHeading size="h2">{{ props.block.title }}</VisionHeading>
        <p :class="bem('subtitle')">{{ props.block.subtitle }}</p>
      </div>
      <div
        :class="bem('review-container')"
      >
        <div :class="bem('review-stars')">
          {{ aggregatedRating.averageStars.toFixed(1) }}
          <VisionStarRating
            :rating="aggregatedRating.averageStars"
            size="large"
            colour="gradient"
          />
        </div>
        <VisionLink
          :to="resolveLocalePath('/reviews')"
          theme="gradient"
          line-link
        >
          Read {{ reviewCount }} Reviews
        </VisionLink>
      </div>
    </div>
    <div :class="bem('scroll-container')">
      <div :class="bem('container')">
        <div
          v-for="column in props.block.columns"
          :key="column.id"
          :class="bem('column')"
        >
          <template
            v-for="item in column.items"
            :key="item.id"
          >
            <CredibilityCard :item="item" />
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
const { resolveLocalePath } = useUrlBuilder()

const reviews = useReviewsStore()

const props = defineProps({
  block: { type: Object, required: true },
  rowPosition: { type: Number, default: 0 },
})

const bem = useBEM('CredibilityRow')

const reviewCount = computed(() => {
  return Intl.NumberFormat().format(reviews.globalCount)
})

const aggregatedRating = computed(() => {
  return reviews.aggregated || {}
})
</script>

<style lang="postcss">
.CredibilityRow {
  @apply w-full max-w-screen-full;

  @screen full {
    @apply mx-auto;
  }

  --credibility-gap: 1.5rem;
}

.CredibilityRow__titles-container {
  @apply w-full flex flex-col gap-5 justify-between items-start mb-10 px-[var(--outer-gutter)];

  @screen md {
    @apply flex-row items-end;
  }
}

.CredibilityRow__subtitle {
  @apply text-md text-grey-500;
}

.CredibilityRow__review-container {
  @apply flex flex-col gap-1 md:items-end;
}

.CredibilityRow__review-title {
  @apply font-bold;
}

.CredibilityRow__review-stars {
  @apply text-grey-500 flex items-center gap-1;
}

.CredibilityRow__scroll-container {
  @apply overflow-x-auto snap-x snap-mandatory;
  scroll-padding-right: var(--outer-gutter);
  scroll-padding-left: var(--outer-gutter);

  &::-webkit-scrollbar {
    display: none;
    scrollbar-width: 0px;
  }
}

.CredibilityRow__container {
  @apply grid grid-cols-4 px-[var(--outer-gutter)] gap-[var(--credibility-gap)] ;
  min-width: 1280px;
}

.CredibilityRow__column {
  @apply flex flex-col gap-[var(--credibility-gap)] snap-start;
}
</style>
